import React from 'react';
import { ROUTES } from '@crema/constants/AppConst';

const SubChannelManagementDetail = React.lazy(() => import('../../modules/subChannelManagement/ChannelList/Detail'));
const SubChannelManagementList = React.lazy(() => import('../../modules/subChannelManagement/ChannelList/List'));
const SubChannelManagementOrderList = React.lazy(() => import('../../modules/subChannelManagement/OrderList/List'));
const SubChannelManagementOrderDetail = React.lazy(() => import('../../modules/subChannelManagement/OrderList/Detail'));
const SubChannelManagementPaymentRecord = React.lazy(() => import('../../modules/subChannelManagement/PaymentList/List'));

export const subChannelManagementConfigs = [
  {
    path: ROUTES.SUB_CHANNEL_MANAGEMENT.LIST,
    element: <SubChannelManagementList />,
  },
  {
    path: ROUTES.SUB_CHANNEL_MANAGEMENT.DETAIL(':id'),
    element: <SubChannelManagementDetail />,
  },
  {
    path: ROUTES.SUB_CHANNEL_MANAGEMENT.ORDER_LIST,
    element: <SubChannelManagementOrderList />,
  },
  {
    path: ROUTES.SUB_CHANNEL_MANAGEMENT.ORDER_DETAIL(':id'),
    element: <SubChannelManagementOrderDetail />,
  },
  {
    path: ROUTES.SUB_CHANNEL_MANAGEMENT.SUB_CHANNEL_PAYMENT_RECORD,
    element: <SubChannelManagementPaymentRecord />,
  },
];
